import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// utility function to trigger snackbar from anywhere in the app
export const showSnackbar = (message, severity = 'info') => {
  window.dispatchEvent(
    new CustomEvent('app-snackbar', {
      detail: { message, severity },
    })
  );
};

// GlobalSnackbar component to be included at the root of the app
const GlobalSnackbar = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  useEffect(() => {
    const handler = (event) => {
      const { message, severity } = event.detail;

      setSnackbar({
        open: true,
        message,
        severity,
      });
    };

    window.addEventListener('app-snackbar', handler);

    return () => {
      window.removeEventListener('app-snackbar', handler);
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={snackbar.severity}>
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
